import { PLAN_ROUTE_NAME } from '@/libs/route-name';

export const planRoute = () => {
    return {
        name: PLAN_ROUTE_NAME.PLAN,
        path: 'package-plans',
        component: () => import('@/pages/plan/index.vue'),
    };
};
